import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Button from "../components/ui/Button";
import Icon from "../components/AppIcon";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { userRole } = useAuth();

  const getDefaultRoute = () => {
    if (userRole === "super_admin" || userRole === "project_admin") {
      return "/host-dashboard";
    } else if (userRole === "cluster_manager") {
      return "/cluster-dashboard";
    } else if (userRole === "worker") {
      return "/worker-dashboard";
    }
    return "/login";
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-6">
          <Icon name="Lock" size={64} className="mx-auto text-destructive mb-4" />
          <h1 className="text-3xl font-bold text-foreground mb-2">Access Denied</h1>
          <p className="text-muted-foreground">
            You don't have permission to access this page.
          </p>
        </div>
        <div className="space-y-3">
          <Button
            variant="default"
            fullWidth
            onClick={() => navigate(getDefaultRoute())}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outline"
            fullWidth
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
